<section class="upload-confirm-form">
  <header class="upload-confirm-form__header">
    <h3 class="upload-confirm-form__title">
      {{ 'upload-confirm.confirm-model-upload' | translate }}
    </h3>
  </header>

  <div class="upload-confirm-form__body">
    <div class="upload-confirm-form__field">
      <span class="upload-confirm-form__label"> {{ 'upload-confirm.project' | translate }}: </span>
      <div class="upload-confirm-form__value-wrapper">
        <ocp-themed-icon name="skyscraper.svg" />
        <span class="upload-confirm-form__value">{{ data.projectName }}</span>
      </div>
    </div>

    <div class="upload-confirm-form__field">
      <span class="upload-confirm-form__label">
        {{ 'upload-confirm.selected-model' | translate }}:
      </span>
      <div class="upload-confirm-form__value-wrapper">
        <ocp-themed-icon name="models.svg" />
        <span class="upload-confirm-form__value">{{ data.selectedModel }}</span>
      </div>
    </div>

    <div class="upload-confirm-form__field">
      <span class="upload-confirm-form__label">
        {{ 'upload-confirm.model-name' | translate }}:
      </span>
      <div class="upload-confirm-form__value-wrapper">
        <ocp-themed-icon name="checklist.svg" />
        <span class="upload-confirm-form__value">{{ data.modelName }}</span>
      </div>
      @if (data.description) {
        <div class="upload-confirm-form__field upload-confirm-form__field--description">
          <span class="upload-confirm-form__value">{{ data.description }}</span>
        </div>
      }
    </div>
  </div>

  <div class="upload-confirm-form__actions">
    <button hlmBtn class="w-full" type="button" (click)="onConfirm()">
      <ocp-themed-icon name="checkmark.svg" mode="swap" />
      {{ 'upload-confirm.confirm-and-upload' | translate }}
    </button>
    <button hlmBtn variant="secondary" class="w-full" type="button" (click)="onCancel()">
      <ocp-themed-icon name="cross.svg" />
      {{ 'upload-confirm.cancel' | translate }}
    </button>
  </div>
</section>
